import React from "react";

function DeFiSmartContractHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-8 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  DeFi Smart Contract Solutions Made Secure and Scalable
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    Unlock the potential of decentralized finance with Xeer
                    Technology’s trusted smart contract development, providing
                    secure, transparent, and innovative DeFi solutions tailored
                    to meet your business needs.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DeFiSmartContractHero;
